import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  EventEmitter,
  Output,
} from "@angular/core";
import { FormGroup } from "@angular/forms";

import { EstructuraBase } from "../model-form/estructura-base";
import { EstructuraControlService } from "../servicios/estructura-control.service";
import { SetFormService } from "../servicios/set-form.service";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

import * as _moment from "moment";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";

declare let $: any;

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD",
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY-MM-DD",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD",
  },
};

@Component({
  selector: "app-dynamic-form",
  templateUrl: "./dynamic-form.component.html",
  styleUrls: ["./dynamic-form.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class DynamicFormComponent implements OnInit {
  @Input() items: EstructuraBase<any>[] = [];
  @Input() descripcion: string;
  @Input() procedimientoDestino: string;
  @Input() parametrosDestino: any[];
  @Input() origenParent: string;
  @Output() dataFormulario = new EventEmitter<any>();

  form: FormGroup;
  payLoad = "";
  expandido = true;

  constructor(
    private fcs: EstructuraControlService,
    private servicioFormulario: SetFormService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.form = this.fcs.toFormGroup(this.items);
  }

  isValidDate(value) {
    const dateWrapper = new Date(value);
    return !isNaN(dateWrapper.getDate());
  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.value);
    const arrNumber = [];

    $("input[data-date]").each(function () {
      arrNumber.push($(this).val());
      const nFecha = _moment($(this).val(), "YYYY-MM-DD").format("YYYY-MM-DD");

      $(this).val(nFecha);
    });

    if (arrNumber.length == 2) {
      /*let date1 = new Date(arrNumber[0]);
  let date2 = new Date(arrNumber[1]);
  let fechaInicial = _moment(date1).format('YYYY-MM-DD');
  let fechaFinal = _moment(date2).format('YYYY-MM-DD');
  alert(fechaInicial);
  alert(fechaFinal);
  if(fechaInicial>fechaFinal){
    alert("fecha inicial mayor");
  }  */

      if (arrNumber[0] > arrNumber[1]) {
        Swal.fire({
          title: this.descripcion,
          text: "La fecha inicial no debe ser mayor a la final. revise.",
          icon: "error",
        });
        return;
      }
    }

    const jsonPayload = this.form.value;
    this.parametrosDestino.forEach((element, indexDestino) => {
      for (const key in jsonPayload) {
        if (jsonPayload.hasOwnProperty(element.key)) {
          const index = key.indexOf(element.key);
          if (index !== -1) {
            if (key.includes("fecha")) {
              jsonPayload[key] = _moment(jsonPayload[key], "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              );
            }
            this.parametrosDestino[indexDestino].value = jsonPayload[key];
          }
        }
      }
    });

    const infoPayload = {
      procedimientoDestino: this.procedimientoDestino,
      infoPayload: this.parametrosDestino,
    };

    const dataResponse = {
      parent: this.origenParent,
      datos: infoPayload,
    };

    this.dataFormulario.emit(dataResponse);

    /*this.servicioFormulario.postFormulario(infoPayload).subscribe(data => {
      Swal.fire({
        title: this.descripcion,
        text: 'Informacion Almacenada Correctamente.',
        icon: "success",
      });
    });


    this.form.reset();
    $(':input').val('');
    $(':select').val('');*/
  }

  resetForm() {
    this.form.reset();
    $(":input").val("");
    //$(':select').val('');
  }
}
